import React from 'react';

function InfoIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_3512_602"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3512_602)">
        <path
          d="M14.7992 22.4H17.1992V14.4H14.7992V22.4ZM15.9922 12C16.3302 12 16.6159 11.8857 16.8492 11.657C17.0826 11.4284 17.1992 11.145 17.1992 10.807C17.1992 10.469 17.0849 10.1833 16.8563 9.95001C16.6276 9.71668 16.3443 9.60001 16.0063 9.60001C15.6682 9.60001 15.3826 9.71433 15.1492 9.94298C14.9159 10.1716 14.7992 10.455 14.7992 10.793C14.7992 11.131 14.9135 11.4167 15.1422 11.65C15.3709 11.8833 15.6542 12 15.9922 12ZM16.0084 28.8C14.2467 28.8 12.5881 28.4667 11.0326 27.8C9.477 27.1333 8.11589 26.2167 6.94922 25.05C5.78255 23.8833 4.86589 22.5227 4.19922 20.9681C3.53255 19.4134 3.19922 17.7523 3.19922 15.9847C3.19922 14.2171 3.53255 12.5611 4.19922 11.0167C4.86589 9.47224 5.78255 8.11668 6.94922 6.95001C8.11589 5.78335 9.47653 4.86668 11.0312 4.20001C12.5858 3.53335 14.2469 3.20001 16.0145 3.20001C17.7821 3.20001 19.4381 3.53335 20.9826 4.20001C22.527 4.86668 23.8826 5.78335 25.0492 6.95001C26.2159 8.11668 27.1326 9.47472 27.7992 11.0241C28.4659 12.5736 28.7992 14.2291 28.7992 15.9908C28.7992 17.7525 28.4659 19.4111 27.7992 20.9667C27.1326 22.5222 26.2159 23.8833 25.0492 25.05C23.8826 26.2167 22.5245 27.1333 20.9751 27.8C19.4256 28.4667 17.7701 28.8 16.0084 28.8Z"
          fill="#4056C7"
        />
      </g>
    </svg>
  );
}

export default InfoIcon;